/**
 * key in the product image collection
 * @deprecated use AppImages settings from theme config instead
 */
export const GALLERY_SLIDER_IMAGE_COLLECTION_KEY = 'GALLERY_SLIDER_IMAGES';

/**
 * themes value for the product slider image formats
 * @deprecated use AppImages settings from theme config instead
 */
export const GALLERY_SLIDER_IMAGE_FORMATS = [
  {
    width: 1024,
    height: 1024,
  },
  {
    width: 2048,
    height: 2048,
  },
];

export const GALLERY_SLIDER_ZOOM = {
  enabled: true,
  maxRatio: 4,
  minRation: 1,
};

